var map = {
	"./aichi.png": "f0c5",
	"./akita.png": "05c49",
	"./aomori.png": "3e8a",
	"./chiba.png": "b0f1",
	"./ehime.png": "7bb9",
	"./fukui.png": "a2d4",
	"./fukuoka.png": "9cb5",
	"./fukushima.png": "2fff",
	"./gifu.png": "4f68",
	"./gunma.png": "73fc",
	"./hiroshima.png": "c11b",
	"./hokkaido.png": "5795",
	"./hyogo.png": "e50e",
	"./ibaraki.png": "42a8",
	"./ishikawa.png": "8317",
	"./iwate.png": "4a4d",
	"./kagawa.png": "136c",
	"./kagoshima.png": "ceaa",
	"./kanagawa.png": "50da",
	"./kochi.png": "a723",
	"./kumamoto.png": "dd80",
	"./kyoto.png": "7d9e",
	"./mie.png": "7f69",
	"./miyagi.png": "97a8",
	"./miyazaki.png": "e88e",
	"./nagano.png": "17dc",
	"./nagasaki.png": "673e",
	"./nara.png": "74bf",
	"./niigata.png": "de23",
	"./oita.png": "44b9",
	"./okayama.png": "a229",
	"./okinawa.png": "f639",
	"./osaka.png": "58e3",
	"./saga.png": "2624",
	"./saitama.png": "9f90",
	"./shiga.png": "3b5d",
	"./shimane.png": "1c94",
	"./shizuoka.png": "de29",
	"./symbol_roulette_anime.gif": "a01d",
	"./tochigi.png": "2342",
	"./tokushima.png": "d667",
	"./tokyo.png": "2262",
	"./tottori.png": "5ad2",
	"./toyama.png": "4161",
	"./wakayama.png": "5dc0",
	"./yamagata.png": "29f0",
	"./yamaguchi.png": "d257",
	"./yamanashi.png": "2c25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "808e";